import { render } from "./GenericDataTable2.vue?vue&type=template&id=72051a4c&scoped=true"
import script from "./GenericDataTable2.vue?vue&type=script&lang=js"
export * from "./GenericDataTable2.vue?vue&type=script&lang=js"

import "./GenericDataTable2.vue?vue&type=style&index=0&id=72051a4c&scoped=true&lang=css"
import "./GenericDataTable2.vue?vue&type=style&index=1&id=72051a4c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72051a4c"]])

export default __exports__